import { render, staticRenderFns } from "./OtherDetails.vue?vue&type=template&id=4289ee0e&"
import script from "./OtherDetails.vue?vue&type=script&lang=js&"
export * from "./OtherDetails.vue?vue&type=script&lang=js&"
import style0 from "./OtherDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports